import api from '@motionelements/core/src/api/base-api-v2';

const mainUrl = '/v2/payout-methods';

// eslint-disable-next-line
export const listPayoutMethods = (params) => { // params: { type: 'payoneer' }
  return api.get(mainUrl, {
    params: {
      ...(params || {}),
      ...api.getLocaleParams(),
    },
  });
};

// eslint-disable-next-line
export const createRegistrationLink = (data) => { // data: { type: 'payoneer' }
  return api.request('post', `${mainUrl}`, {
    data,
    params: {
      ...api.getLocaleParams(),
    },
  });
};

// eslint-disable-next-line
export const deletePayoutMethod = (payoutMethodId) => {
  return api.request('delete', `${mainUrl}/${payoutMethodId}`);
};
